<script setup>
import {computed} from 'vue';
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const props = defineProps({
    googlePixelId: {
        type: String,
        default: '',
    },
    metaPixelId: {
        type: String,
        default: '',
    },
    linkedinPixelId: {
        type: String,
        default: '',
    },
});

const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.tracking'));
</script>

<template>
    <div class="w-full">
        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('navigation:backOffice.sidebar.myCompany.settings.tracking') }}</h1>
            </div>
        </frosted-bar>

        <card-tabbed class="mt-8">
            <card-tabbed-tab
                title="Google Analytics"
                value="google-analytics"
                :active="true"
            >
                <p>
                    <mf-translate domainkey="setting:tracking.justAddTheId"></mf-translate>
                    <br>
                    <mf-translate domainkey="setting:tracking.forReference"></mf-translate>
                    <br>
                    <code class="text-gray-600">gtag('config', '<strong class="text-black">XXXXXXXXXXXXX</strong>');</code>
                </p>
                <content-editable :url="route('pages.google')" name="google_id">
                    <p class="myflow-basic-input min-h-[2em] !mb-0">{{ props.googlePixelId }}</p>
                </content-editable>
            </card-tabbed-tab>

            <card-tabbed-tab
                title="Meta (Facebook &amp; Instagram)"
                value="meta"
            >
                <p>
                    <mf-translate domainkey="setting:tracking.justAddTheId"></mf-translate>
                    <br>
                    <mf-translate domainkey="setting:tracking.forReference"></mf-translate>
                    <br>
                    <code class="text-gray-600">fbq('init', '<strong class="text-black">XXXXXXXXXXXXXXX</strong>');</code>
                </p>
                <content-editable :url="route('pages.meta')" name="meta_id">
                    <p class="myflow-basic-input min-h-[2em] !mb-0">{{ props.metaPixelId }}</p>
                </content-editable>
            </card-tabbed-tab>

            <card-tabbed-tab
                title="LinkedIn"
                value="linkedin"
            >
                <p>
                    <mf-translate domainkey="setting:tracking.justAddTheId"></mf-translate>
                    <br>
                    <mf-translate domainkey="setting:tracking.forReference"></mf-translate>
                    <br>
                    <code class="text-gray-600">_linkedin_partner_id = "<strong class="text-black">XXXXXXX</strong>";</code>
                </p>
                <content-editable :url="route('pages.linkedin')" name="linkedin_id">
                    <p class="myflow-basic-input min-h-[2em] !mb-0">{{ props.linkedinPixelId }}</p>
                </content-editable>
            </card-tabbed-tab>
        </card-tabbed>
    </div>
</template>
